/** @file Tells whether an element takes part in layout: display:none and detached elements do not. */

/** True when the element has a layout box, so `focus()` can succeed on it. */
export function isRendered(element: { getClientRects: () => { length: number } }): boolean {
  return element.getClientRects().length > 0;
}
